export const getEnv = (key: keyof Window['env']): string => {
  const envObj = typeof window !== 'undefined' ? window.env : undefined;
  return envObj?.[key] ?? process.env[key] ?? '';
};